export const sendToAmplitude = (event: string, value?: Record<string, string | string[]>) => {
    // @ts-ignore
    if (!event || !window.amplitude) return;

    // @ts-ignore
    window.amplitude.track(event, value);
};
